import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

export class FinanceServiceHandler extends BaseService {
  isAuditButtonClicked: boolean;
  forAuditSearchList: boolean;

  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, '');
  }

  public init(modelNameList: string[]): Observable<Object> {
    return;
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean): Observable<Object> {
    return;
  }
  public process(id: any, modelNameList: string[]): Observable<Object> {
    return;
  }
  public find(executeSearch?: boolean, searchCriteriaData?: any): Observable<Object> {
    return;
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return null;
  }

  public getDocument(guid) {
    let body = {
      GUID: guid,
      FetchData: {
        isMetadataRequired: true,
        language: 'EN',
      },
    };
    let path = this.getURLValue('DOCUMENTS');

    return this.httpPost(`${path}/getDocuments`, body, null, true);
  }

  public downloadPaymentStatement(dmsreferenceSeq) {
    let body = {
      referenceSeq: dmsreferenceSeq.toString(),
    };
    let path = 'api/finance';
    return this.httpPost(`${path}/paymentStatement/download`, body, null, true);
  }
}
